<template>
    <div class="component custom-cursor" :class="[cursorState, { 'is-hidden': hideCursor }]" :style="cursorPoint">
        <div class="animation-wrapper">
            <svg class="cursor-icon" viewBox="0 0 100 100">
                <path d="M0,50l25.3,25.2V53.3H100v-6.6H25.3V24.8L0,50z"></path>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomCursor',
        data() {
            return {
                xChild: 0,
                yChild: 0,
                xParent: 0,
                yParent: 0,
                hideCursor: true,
                cursorState: 'cc-default',
            };
        },
        computed: {
            cursorPoint() {
                return `transform: translateX(${this.xChild - 25}px) translateY(${this.yChild -
                    25}px) translateZ(0) translate3d(0, 0, 0);`;
            },
        },
        methods: {
            moveCursor(e) {
                this.xChild = e.clientX;
                this.yChild = e.clientY;
                setTimeout(() => {
                    this.xParent = e.clientX - 15;
                    this.yParent = e.clientY - 15;
                }, 100);
            },
        },
        mounted() {
            document.addEventListener('mousemove', this.moveCursor);
            document.addEventListener('mouseleave', e => {
                this.hideCursor = true;
            });
            const customCursorTriggerZones = document.querySelectorAll('.custom-cursor-trigger-zone');
            customCursorTriggerZones.forEach(element => {
                element.addEventListener('mouseenter', e => {
                    this.cursorState = element.dataset.cursorState;
                    this.hideCursor = false;
                });
                element.addEventListener('mouseleave', e => {
                    this.cursorState = element.dataset.cursorState;
                    this.hideCursor = true;
                });
            });
        },
    };
</script>

<style lang="scss">
    .custom-cursor-trigger-zone {
        cursor: none;
    }

    .custom-cursor {
        top: 0;
        left: 0;
        position: fixed;
        width: 10px;
        height: 10px;
        pointer-events: none;
        user-select: none;
        border-radius: 100%;
        background: #000;
        z-index: 5;
        backface-visibility: hidden;
        will-change: transform;
        transition: background-color 0.3s;

        .animation-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transform-origin: center center;
            transition: transform cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.3s;
        }

        .cursor-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 40%;

            path {
                fill: #ffffff;
            }
        }

        &.arrow-right {
            width: 60px;
            height: 60px;

            .animation-wrapper {
                transform: rotate(180deg);
            }
        }

        &.arrow-left {
            width: 60px;
            height: 60px;

            .animation-wrapper {
                transform: rotate(0deg);
            }
        }

        &.arrow-down {
            width: 60px;
            height: 60px;

            .animation-wrapper {
                transform: rotate(270deg);
            }
        }

        &.is-hidden {
            display: none;
        }
    }
</style>
